const REMOTE_IMAGE_PROXY_PATH = '/api/proxy-remote-image';
const REMOTE_IMAGE_PROXY_BASE_URL =
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost';

export function isWweHostedImageUrl(rawUrl = '') {
  if (!rawUrl || typeof rawUrl !== 'string') return false;

  try {
    const parsedUrl = new URL(rawUrl, REMOTE_IMAGE_PROXY_BASE_URL);
    const hostname = parsedUrl.hostname.toLowerCase();

    return parsedUrl.protocol === 'https:' &&
      (hostname === 'www.wwe.com' || hostname.endsWith('.wwe.com'));
  } catch (error) {
    return false;
  }
}

export function getCorsSafeImageUrl(rawUrl = '') {
  if (!rawUrl) return '';
  if (!isWweHostedImageUrl(rawUrl)) return rawUrl;

  return `${REMOTE_IMAGE_PROXY_PATH}?url=${encodeURIComponent(rawUrl)}`;
}
